import React, { useState } from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import Typography from "@mui/material/Typography";
import { format } from "date-fns";
import { FormControlLabel, Switch } from "@mui/material";

const ExploreJourneyDataView = ({ users, data }) => {
  const [showStagesWithData, setShowStagesWithData] = useState(true);
  const [showGeneralstage, setShowGeneralstage] = useState(true);
  console.log("filtered data from explore", users);
  console.log("Data", data);

  const uniqueEntriesByStage = {};
 
  const internal = {};

  data.forEach((item) => {
    const { stage, alt_name } = item;
    uniqueEntriesByStage[stage] = [];
    internal[alt_name] = [];
  });

  
  users.forEach((user) => {
    const { stage, status, date, alt_name } = user;
  
    if (!uniqueEntriesByStage[stage].some((entry) => entry.status === status)) {
      uniqueEntriesByStage[stage].push({ status, date });
    }

    if (!internal[alt_name].some((entry) => entry.status === status)) {
      internal[alt_name].push({ status, date });
    }
   
  });

  let newArray = Object.keys(uniqueEntriesByStage);
  let newObj = uniqueEntriesByStage;

  if (showGeneralstage) {
    newArray = Object.keys(internal);
    newObj = internal;
  } else {
    newArray = Object.keys(uniqueEntriesByStage);
    newObj = uniqueEntriesByStage;
  }

  return (
    <>
      <div>
        <FormControlLabel
          control={
            <Switch
              value={showStagesWithData}
              onClick={() => {
                setShowStagesWithData(!showStagesWithData);
                console.log("Switch toggled:", !showStagesWithData);
              }}
              defaultChecked
            />
          }
          label="Stages with data"
        />
      </div>
      <FormControlLabel
        control={
          <Switch
            value={showGeneralstage}
            onClick={() => {
              setShowGeneralstage(!showGeneralstage);
            }}
            defaultChecked
          />
        }
        label="Show External Stages"
      />
      <Timeline position="alternate">
        {newArray.map((stage) => (
          <TimelineItem
            key={stage}
            hidden={showStagesWithData ? newObj[stage].length === 0 : false}
          >
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#FF762B" }}
                component="span"
              >
                {stage}
              </Typography>
              {newObj[stage].length > 0 ? (
                newObj[stage].map((entry, index) => (
                  <div key={index}>
                    <span>
                      {format(new Date(entry.date), "d MMMM yyyy")} -{" "}
                      {entry.status}
                    </span>
                  </div>

                
                ))
              ) : (
                <Typography variant="body2">None</Typography>
              )}
            </TimelineContent>
          </TimelineItem>
        ))}
      </Timeline>
    </>
  );
};

export default ExploreJourneyDataView;






